// extracted by mini-css-extract-plugin
export var points = "index-module--points--Z57Ec";
export var point = "index-module--point--OF-Ez";
export var point__title = "index-module--point__title--O+KH0";
export var point__text = "index-module--point__text--DYbwE";